import React from 'react';

const DIAMOND = 'M12 2 22 12 12 22 2 12Z';

// The trail sign shape for a run's difficulty
const RunIcon = ({ colorName, size = 14 }) => {
  if (colorName === 'double_black') {
    return (
      <svg width={size * 1.5} height={size} viewBox="0 0 36 24" fill="currentColor" aria-hidden="true">
        <path d={DIAMOND} />
        <path d={DIAMOND} transform="translate(12 0)" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      {colorName === 'black' && <path d={DIAMOND} />}
      {colorName === 'blue' && <rect x="3" y="3" width="18" height="18" rx="2" />}
      {colorName !== 'black' && colorName !== 'blue' && <circle cx="12" cy="12" r="10" />}
    </svg>
  );
};

export default RunIcon;
